const accentGradient = {
  primary: {
    hover: 'var(--accent-gradient-primary-hover)',
    active: 'var(--accent-gradient-primary-active)',
    primary: 'var(--accent-gradient-primary-primary)',
  },
  secondary: {
    hover: 'var(--accent-gradient-secondary-hover)',
    active: 'var(--accent-gradient-secondary-active)',
    primary: 'var(--accent-gradient-secondary-primary)',
  },
};

const cardGradient = {
  icon: 'linear-gradient(180deg, #FFFFFF -89.2%, rgba(255, 255, 255, 0) 115.91%)',
  border:
    'linear-gradient(180deg, #FFFFFF -38.14%, rgba(255, 255, 255, 0) 115.91%)',
};

export const gradients = {
  cardGradient,
  accentGradient,
};
